module.exports = __webpack_public_path__ + "img/banner4 (1).9be2a5d5.jpg";